import { theme as antdTheme } from 'antd';
import { ThemeConfig } from 'antd/es/config-provider/context';

// Dark theme configuration
export const darkTheme: ThemeConfig = {
  algorithm: antdTheme.darkAlgorithm,
  token: {
    colorPrimary: '#2563EB',
    colorBgBase: '#0A0A0B',
    colorBgContainer: '#1A1A1B',
    colorBgElevated: '#1F1F20',
    colorBorder: 'rgba(255, 255, 255, 0.1)',
    colorText: '#ECECEC',
    colorTextSecondary: '#B8B8B8',
    colorTextTertiary: '#8A8A8A',
    colorSuccess: '#10B981',
    colorWarning: '#F59E0B',
    colorError: '#EF4444',
    colorInfo: '#2563EB',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontSize: 14,
    borderRadius: 10,
    controlHeight: 36,
  },
  components: {
    Layout: {
      siderBg: '#0F0F10',
      headerBg: '#1A1A1B',
      bodyBg: '#0A0A0B',
    },
    Menu: {
      darkItemBg: 'transparent',
      darkItemSelectedBg: '#2563EB',
      darkItemHoverBg: 'rgba(255, 255, 255, 0.05)',
      darkItemColor: '#B8B8B8',
      darkItemSelectedColor: '#FFFFFF',
    },
    Card: {
      colorBgContainer: '#1A1A1B',
      colorBorderSecondary: 'rgba(255, 255, 255, 0.1)',
    },
    Table: {
      colorBgContainer: '#1A1A1B',
      colorBorderSecondary: 'rgba(255, 255, 255, 0.1)',
      headerBg: '#1F1F20',
    },
    Button: {
      colorPrimary: '#2563EB',
      primaryShadow: '0 2px 8px rgba(37, 99, 235, 0.3)',
    },
    Input: {
      colorBgContainer: '#1F1F20',
      colorBorder: 'rgba(255, 255, 255, 0.15)',
    },
    Modal: {
      contentBg: '#1A1A1B',
      headerBg: '#1A1A1B',
    },
    Dropdown: {
      colorBgElevated: '#1F1F20',
    },
  },
};

// Light theme configuration - AI Chatbot optimized
export const lightTheme: ThemeConfig = {
  algorithm: antdTheme.defaultAlgorithm,
  token: {
    colorPrimary: '#2563EB',
    colorBgBase: '#FFFFFF',
    colorBgContainer: '#F8F9FA',
    colorBgElevated: '#FFFFFF',
    colorBorder: 'rgba(0, 0, 0, 0.08)',
    colorText: '#1A1A1A',
    colorTextSecondary: '#6B7280',
    colorTextTertiary: '#9CA3AF',
    colorSuccess: '#10B981',
    colorWarning: '#F59E0B',
    colorError: '#EF4444',
    colorInfo: '#2563EB',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontSize: 14,
    borderRadius: 10,
    controlHeight: 36,
  },
  components: {
    Layout: {
      siderBg: '#FFFFFF',
      headerBg: '#FFFFFF',
      bodyBg: '#F8F9FA',
    },
    Menu: {
      itemBg: 'transparent',
      itemSelectedBg: '#EEF2FF',
      itemHoverBg: '#F3F4F6',
      itemColor: '#6B7280',
      itemSelectedColor: '#2563EB',
    },
    Card: {
      colorBgContainer: '#FFFFFF',
      colorBorderSecondary: 'rgba(0, 0, 0, 0.08)',
    },
    Table: {
      colorBgContainer: '#FFFFFF',
      colorBorderSecondary: 'rgba(0, 0, 0, 0.08)',
      headerBg: '#F8F9FA',
    },
    Button: {
      colorPrimary: '#2563EB',
      primaryShadow: '0 2px 8px rgba(37, 99, 235, 0.2)',
    },
    Input: {
      colorBgContainer: '#FFFFFF',
      colorBorder: 'rgba(0, 0, 0, 0.15)',
    },
    Modal: {
      contentBg: '#FFFFFF',
      headerBg: '#FFFFFF',
    },
    Dropdown: {
      colorBgElevated: '#FFFFFF',
    },
  },
};

// Function to get theme based on mode
export const getTheme = (mode: 'light' | 'dark'): ThemeConfig => {
  return mode === 'light' ? lightTheme : darkTheme;
};

// Export dark theme as default for backward compatibility
export const constructionTheme = darkTheme;
